import { helpers } from "vuelidate/lib/validators";

export const accountNumberValidator = helpers.regex("accountNumberValidator",  /^[\s\d\(\)\-]+$/m);